import './App.css';
import Map from './Map/Map.js'
import React, {useEffect, useState, useRef} from 'react';
import UACTNavbar from './Navbar.js';
import orgsCsv from './orgs.csv'
import * as Papa from 'papaparse';

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import InfoSection from './InfoSection.js';

const images = require.context("./img/logos", true)

function App() {
  const [orgs, setOrgs] = useState({data:[], countyInfo: {}})
  const [loaded, setLoaded] = useState(false)
  const mapRef = useRef(null)
  useEffect(() => {
    if (loaded) {
      return
    }
    fetch(orgsCsv)
      .then(r => r.text())  
      .then( responseText => {
          // -- parse csv
          let {data} = Papa.parse(responseText);  
          let countyInfo = {}
          data = data.map((element, id) => {
            let [countyID, town, name, missionUA, focusUA, contactUA, 
              missionEN, focusEN, contactEN, email, link, img] = element
            if(!(countyID in countyInfo)) {
              countyInfo[countyID] = 0
            }
            const countyToAttach = countyID !== 'N/A' ? countyID : 'DUBLIN'
            countyInfo[countyToAttach] ++;
            img = img !== 'N/A' ? images(`./${img}`) : images('./na.jpg')
            return{
              id,
              countyID, town, name, link, img, 
              missionUA, focusUA, contactUA, missionEN, focusEN, contactEN, email,
              countyIndex: countyInfo[countyToAttach]
            }
          });
          setOrgs({data, countyInfo})
          setLoaded(true)
      });
    }, [loaded]);
  const onMapJumpClick = (e) => {
    setTimeout(() => mapRef.current.scrollIntoView({behaviour: "smooth"}), 0)
  }
  
  return (
    <div className="App">
      <UACTNavbar />
      <Container>
        <Row>
          <Col md={12} xs={12} xl={6}>
            <InfoSection onMapJumpClick={onMapJumpClick}/>
          </Col>
          <Col >
            <div ref={mapRef}>

              <Map orgs={orgs}></Map>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default App;
